import Modal from "react-modal";
import * as Progress from "@radix-ui/react-progress";
import { useDownloadStore } from "../../../utils/useDownloadStore";
import { cancelDownload } from "../../../mail/downloadAttachment";
import styles from "./DownloadManagerModal.module.css";

Modal.setAppElement("#root");

const headerModalStyles = {
    content: {
        width: "50%",
        height: "50%",
        margin: "auto",
        padding: "20px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        overflow: "scroll",
    },
    overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 50,
    },
};

export default function DownloadManagerModal({ visible, onClose }) {
    const downloads = useDownloadStore((s) => s.activeDownloads);

    return (
        <Modal
            isOpen={visible}
            onRequestClose={onClose}
            contentLabel="Download Manager"
            style={headerModalStyles}
        >
            <div className={styles.headerRow}>
                <h2 className={styles.headerText}>Download Manager</h2>
                <button onClick={onClose} className={styles.closeButton} aria-label="Close">
                    ✖
                </button>
            </div>

            <div className={styles.downloadList}>
                {downloads.length === 0 && (
                    <div className={styles.emptyText}>No downloads in progress.</div>
                )}
                {downloads.map((file) => (
                    <div key={file.id} className={styles.downloadItem}>
                        <div className={styles.downloadMeta}>
                            <div className={styles.downloadName}>{file.name}</div>
                            <div className={styles.downloadStatus}>
                                {file.done ? "Done" : `${Math.floor(file.progress)}%`}
                            </div>
                            <button
                                className={styles.cancelButton}
                                onClick={() => cancelDownload(file.id)}
                                title="Cancel Download"
                            >
                                ✖
                            </button>
                        </div>
                        <Progress.Root className={styles.progressBarRoot}>
                            <Progress.Indicator
                                className={styles.progressBarIndicator}
                                style={{ width: `${file.progress}%` }}
                            />
                        </Progress.Root>
                    </div>
                ))}
            </div>
        </Modal>
    );
}
